import { ActionTree } from 'vuex';
import axios from 'axios';
import { ProfileState, User, RootState, Proficiency } from './profile-types';

export const actions: ActionTree<ProfileState, RootState> = {
  updateEmployeeProfile(context, payload): any {
    setTimeout(() => {
      axios.post('https://vb0bti0a28.execute-api.ap-south-1.amazonaws.com/poc/mdm-svc/update-user-skills', payload).then(
        () => {
          context.dispatch('getEmployeeProfile');
        },
        (error) => {
          console.log(error);
          context.commit('profileError');
        },
      );
    }, 1000);
  },
  async getEmployeeProfile(context): Promise<any> {
    await axios({ url: 'https://vb0bti0a28.execute-api.ap-south-1.amazonaws.com/poc/mdm-svc/get-user-skills?ohrid=103004754' }).then(
      (response) => {
        const payload: User = response && response.data;
        context.commit('setEmployeeInState', payload);
      },
      (error) => {
        console.log(error);
        context.commit('profileError');
      },
    );
  },
  async getSkillsProficiency({ commit }): Promise<any> {
    await axios({ url: 'https://vb0bti0a28.execute-api.ap-south-1.amazonaws.com/poc/mdm-svc/get-ProficienciesList?orderBy=id' }).then(
      (response) => {
        const payload: Proficiency = response && response.data;
        commit('setSkillsProficiencyInState', payload);
      },
      (error) => {
        console.log(error);
        commit('profileError');
      },
    );
  },
};
